window.addEventListener('load', function(){

    /*********************************************************** 
        Acordion effect for faq list items
    ************************************************************/
   
    var doencasItems = document.getElementsByClassName('doencas-item');
    for (i = 0; i < doencasItems.length; i++) {

      doencasItems[i].addEventListener("click", (e) => {
            
            // clear elms min-height & state
            for (i = 0; i < doencasItems.length; i++) {
                if (doencasItems[i] != e.currentTarget){
                  doencasItems[i].ariaExpanded = 'false';
                }
                doencasItems[i].getElementsByClassName('doencas-item-description')[0].style.maxHeight = null;
            }
            
            // register elm description
            var description = e.currentTarget.getElementsByClassName('doencas-item-description')[0];  
            
            // current areaExpended State
            e.currentTarget.ariaExpanded = e.currentTarget.ariaExpanded !== 'true';
            var expended = (e.currentTarget.ariaExpanded === 'true');
            
            // add height to clicked item
            if(expended == true) {
                description.style.maxHeight = description.scrollHeight + "px";
            }
        });
    }
});